import React, { useMemo } from 'react';
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Switch, Button, formControlClasses } from "@mui/material";
import { Link } from 'react-router-dom';

function DataGridAgentCommission({
  data,
  setSelectedAgentId,
  setShowAddCommissionToAgentModal,
  setSelectedCheckBoxes,
  selectedCheckBoxes,
}) {
  const handleToggle = (id) => {
    setSelectedCheckBoxes(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((selectedId) => selectedId !== id) // Remove if already selected
          : [...prevSelected, id], // Add if not selected
    );
  };
  const handleToggleAll = () => {
    if (data) {
      if (data?.data?.length === selectedCheckBoxes.length) {
        // If all are selected, clear the list
        setSelectedCheckBoxes([]);
      } else {
        // Otherwise, select all
        const allCheckBoxesId = data?.data?.map((item) => item.id);
        setSelectedCheckBoxes([...allCheckBoxesId]);
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        accessor: "#",
        Header: () => {
          return (
            <div className="text-center cursor-pointer" onClick={() => handleToggleAll()}>
              <input
                type="checkbox"
                checked={data?.data?.length !== 0 && data?.data?.length === selectedCheckBoxes.length}
                onChange={() => { }}
                className="ml-1 ml-xl-6 pl-6 cursor-pointer"
                disabled={data === undefined}
              />
            </div>
          );
        },
        minWidth: 50,
        Cell: ({ row }) => {
          return <div className="text-center cursor-pointer" onClick={() => handleToggle(row.original.id)}>
            <input
              type="checkbox"
              checked={selectedCheckBoxes.includes(row.original.id)}
              onChange={() => { }}
              className="ml-1 ml-xl-6 pl-6 cursor-pointer"
              disabled={data === undefined}
            />
          </div>
        },
      },
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "agentCompanyName",
        Header: "نام نماینده",
        minWidth: '100px',
      },
      {
        accessor: "agentCommissionName",
        Header: "گروه کمیسیون",
        minWidth: '100px',
      },
      {
        accessor: "agentCommissionCommissionType",
        Header: "نوع کمیسیون",
        minWidth: '100px',
      },
      {
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.isActive ? true : false}
              value="row.original.isActive"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </div>
        ),
      },
      {
        Header: 'عملیات',
        accessor: '',
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}
            <i className='far fa-edit text-small btn btn-light-primary'
              onClick={() => {
                setShowAddCommissionToAgentModal(true)
                setSelectedAgentId(row.original.id)
              }}></i>
          </div>
        )
      }
    ],
    [selectedCheckBoxes, data],
  );


  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: 'advance',
    button: {
      excel: false,
      print: false
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className='fa fa-chevron-right'></i>,
        next: <i className='fa fa-chevron-left'></i>,
        last: "Last"
      }
    }
  }
  return (
    <div>
      <DataTable
        config={config}
        columns={columns}
        data={data}
      />
    </div>
  )
}

export default DataGridAgentCommission;